import type { NavigationItemData } from '@/types/navigation'
import styles from './NavigationItem.module.css'

interface NavigationItemProps {
  item: NavigationItemData
  active: boolean
  onSelect: (id: NavigationItemData['id']) => void
}

export function NavigationItem({ item, active, onSelect }: NavigationItemProps) {
  const Icon = item.icon

  return (
    <button
      type="button"
      className={`${styles.root} ${active ? styles.active : ''}`}
      onClick={() => onSelect(item.id)}
      aria-current={active ? 'page' : undefined}
    >
      <Icon className={styles.icon} aria-hidden="true" />
      <span className={styles.copy}>
        <span className={styles.label}>{item.label}</span>
        <span className={styles.description}>{item.description}</span>
      </span>
    </button>
  )
}
